import { NgModule } from '@angular/core';

import { ApContentComponent, ApContentPipe, ApContentService } from '@ap/content';
import { ApPanelComponent } from '@ap/panel';

import { ConversationalChatDisclaimerComponent } from './conversational-chat-disclaimer.component';

/**
 * @ngdoc module
 * @name ConversationalChatDisclaimerModule
 **/
@NgModule({
    declarations: [ConversationalChatDisclaimerComponent],
    imports: [ApContentPipe, ApContentComponent, ApPanelComponent],
    exports: [ConversationalChatDisclaimerComponent],
    providers: [ApContentService]
})
export class ConversationalChatDisclaimerModule {}
